export default __webpack_public_path__ + "static/media/push32.3ebdd250.gif";